import React from 'react'
import { PageContain } from './components'
import '../../Assets/Scss/View_Company.scss'

const ViewCompany = () => {
  return (
    <div className='View_Company_Wrapper' >
      <PageContain />
    </div>
  )
}

export default ViewCompany